import React from 'react';
import IsConnected from '../../IsConnected/IsConnected'
import EditGallery from './EditGallery'

class ParselEditGallery extends React.Component {

 render() {
   const {...props} = this.props
   return (
     <IsConnected Component={EditGallery} {...props}/>
   )
 }
}



export default ParselEditGallery;
